import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useMemo } from 'react';
import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import { VariableSizeList } from 'react-window';
import { walkTreeStrategy } from './walkStrategy.js';
import { RowSizes } from '../../rowSizes.js';
import { dataGridBlockName } from '../../blockNames.js';
import '@babel/runtime/helpers/esm/toConsumableArray';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var blockName = "".concat(dataGridBlockName, "-group-row-header");
var GroupRowHeaderWrapper = aggregatedClasses('div')(blockName);
var GroupRowHeaderTitle = aggregatedClasses('div')(blockName, 'title');
var GroupingPlugin = createInstancePlugin('groupedRows', {
  decorateGrid: function decorateGrid(grid) {
    var _grid$getInstance = grid.getInstance(),
        columns = _grid$getInstance.columns,
        composedRows = _grid$getInstance.composedRows; // eslint-disable-next-line react-hooks/rules-of-hooks


    var detailColumns = useMemo(function () {
      return columns.map(function (column) {
        return _objectSpread(_objectSpread({}, column), {}, {
          customRenderer: column.detailCustomRenderer
        });
      }).filter(function (col) {
        return !col.expandableColumn;
      });
    }, [columns]);
    var flatRows = [];
    walkTreeStrategy({
      data: composedRows,
      cb: function cb(n) {
        return flatRows.push(n);
      }
    });
    return {
      detailColumns: detailColumns,
      composedRows: flatRows
    };
  },
  getBodyProps: function getBodyProps(bodyProps, grid) {
    var _grid$getInstance2 = grid.getInstance(),
        rows = _grid$getInstance2.composedRows; // implementation of expandable row single column with aggregation


    var getItemSize = function getItemSize(index) {
      var rowData = rows[index];
      if (!rowData) return RowSizes.normal;
      return rowData._isGroup || rowData.isGroup ? RowSizes.compact : RowSizes.normal;
    }; // eslint-disable-next-line no-unused-vars


    var getListHeight = function getListHeight() {
      var size = rows.reduce(function (h, r) {
        var rowHeight = r._isGroup || r.isGroup ? RowSizes.compact : RowSizes.normal;
        return h + rowHeight;
      }, 0);
      return size;
    };

    return _objectSpread(_objectSpread({}, bodyProps), {}, {
      getListHeight: getListHeight,
      listComponent: VariableSizeList,
      listProps: {
        itemSize: getItemSize
      }
    });
  },
  composeRows: function composeRows(rows, grid) {
    var _grid$getInstance3 = grid.getInstance(),
        composedRows = _grid$getInstance3.composedRows,
        rowKey = _grid$getInstance3.props.rowKey;

    if (Array.isArray(rows)) {
      var filterIds = rows.map(function (r) {
        return r.data[rowKey];
      });
      return composedRows.filter(function (c) {
        return filterIds.includes(c.data[rowKey]);
      }).map(function (r) {
        return _objectSpread(_objectSpread({}, r.data), {}, {
          children: Array.isArray(r.data.children) ? r.data.children.filter(function (c) {
            return filterIds.includes(c[rowKey]);
          }) : r.data.children,
          _isGroup: r.isGroup
        });
      }).filter(function (g) {
        return g.children === undefined || g.children.length > 0;
      });
    }

    return _objectSpread(_objectSpread({}, rows), {}, {
      allRows: rows.allRows.map(function (r) {
        return _objectSpread(_objectSpread({}, r.data), {}, {
          _isGroup: r.isGroup
        });
      }),
      rows: rows.rows.map(function (r) {
        return _objectSpread(_objectSpread({}, r.data), {}, {
          _isGroup: r.isGroup
        });
      })
    });
  },
  decorateRenderers: function decorateRenderers(renderers, grid) {
    var Row = renderers.body.row; // eslint-disable-next-line react-hooks/rules-of-hooks

    renderers.body.row = useMemo(function () {
      return (// eslint-disable-next-line react/display-name
        // eslint-disable-next-line react/prop-types
        function (_ref) {
          _ref.isExpanded;
              var rowProps = _objectWithoutProperties(_ref, ["isExpanded"]);

          var _grid$getInstance4 = grid.getInstance(),
              composedRows = _grid$getInstance4.composedRows; // // https://jira.elliemae.io/browse/PUI-1667


          var node = composedRows[rowProps.index] ? composedRows[rowProps.index] : rowProps.rowData;
          var groupedRowsRenderHeader = grid.props.groupedRowsRenderHeader; // eslint-disable-next-line no-underscore-dangle

          if (node && node._isGroup) {
            return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GroupRowHeaderWrapper, rowProps, /*#__PURE__*/React.createElement(GroupRowHeaderTitle, null, groupedRowsRenderHeader ? groupedRowsRenderHeader(node) : 'Group')));
          }

          return /*#__PURE__*/React.createElement(Row, rowProps);
        }
      );
    }, []);
    return renderers;
  }
});

export { GroupingPlugin };
//# sourceMappingURL=GroupingPlugin.js.map
